import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import ScrollToTop from "./helpers";

import { Home } from './home'
import { NewsUpdates } from "./newsupdates/newsupdates"
import { Page0 } from './page0'
import { Page1 } from './page1'
import { BuyNUNISYNTH } from "./buynunisynth";

import firebase from "firebase/app";
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";
// Add the Firebase products that you want to use
// import "firebase/auth";
// import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyApbScEstu-Dt9d0y1IkweORd4oD8HQ9WA",
  authDomain: "nunisynth-website.firebaseapp.com",
  projectId: "nunisynth-website",
  storageBucket: "nunisynth-website.appspot.com",
  messagingSenderId: "814798004748",
  appId: "1:814798004748:web:4783e7c7ceb058970b0429",
  measurementId: "G-MPYFYW9D5V"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default function App() {
  return (
    <Router>
      <ScrollToTop>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route path="/buynunisynth">
            <BuyNUNISYNTH/>
          </Route>
          <Route path="/newsupdates">
            <NewsUpdates/>
          </Route>
          <Route path="/create">
            <Page0 />
          </Route>
          <Route path="/experiment">
            <Page1 />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </ScrollToTop>
    </Router>
  );
}